// wait until DOM is ready
document.addEventListener("DOMContentLoaded", function(event){


    //wait until images, links, fonts, stylesheets, and js is loaded
    window.addEventListener("load", function(e){

        gsap.registerPlugin(ScrollTrigger);
        gsap.registerPlugin(SplitText);

        // split elements with the class "split" into words and characters
        let split = SplitText.create("div#shopify-section-template--26274025537826__main h1", { type: "words, chars" });
        gsap.set('div#shopify-section-template--26274025537826__main h1', { opacity:1 });
        // now animate the characters in a staggered fashion
        gsap.from(split.words, {
        duration: 1, 
        x: -100,       // animate from 100px below
        autoAlpha: 0, // fade in from opacity: 0 and visibility: hidden
        stagger: 0.1, // 0.05 seconds between each 
        onComplete: () => {
            gsap.to('div#shopify-section-template--26274025537826__main span.price,.text-block--AV1BEOGNxSnMxRCs0S__text_aEtTtq,div#shopify-section-template--26274025537826__main .variant-picker,div#shopify-section-template--26274025537826__main .buy-buttons-block', {
            duration: 1, 
            y: 0,       
            opacity: 1, 
            stagger: 0.1, // stagger start times
            });
        },
        });

        gsap.from('.two-col-tabs__left',{
            opacity:0,
            x:-100,
            duration:2,
            scrollTrigger: {
                trigger: "div#shopify-section-template--26274025537826__product_overview_custom_LpyziT",
                scroller: "body",
                //markers: true,
                start: "top 50%",
                end: "top 10%",
                scrub:true,
            },
        });
        gsap.from('.two-col-tabs__right',{
            opacity:0,
            x:100,
            duration:2,
            scrollTrigger: {
                trigger: "div#shopify-section-template--26274025537826__product_overview_custom_LpyziT",
                scroller: "body",
                //markers: true,
                start: "top 50%",
                end: "top 10%",
                scrub:true,
            },
        });

        gsap.from('.gloss-sys-section-grid .img-two-text__image',{
            opacity:0,
            scale:0,
            duration:2,
            scrollTrigger: {
                trigger: ".gloss-sys-section",
                scroller: "body",
                //markers: true,
                start: "top 50%",
                end: "top 10%",
                scrub:true,
            },
        });
        


    }, false);

});
